import React from "react";
import { Formik } from "formik";
import {withStyles, FormControl, FormHelperText} from "@material-ui/core";
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import {getDateFormat} from "./date";

const styles = theme => ({
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "200px",
        marginRight: '4%'

    },
    formControl: {
        display: 'inline-block',
        width: "435px"
    },
});

const DataRangeForm = props => {
    const { classes, initialValues, translations, filterDataRange, setValue, minDate, maxDate } = props;

    return (
        <div >
            <Formik initialValues={initialValues}>
                {formikProps => {
                    const { values, touched, errors, handleBlur, setFieldValue } = formikProps;

                    const filter = (name, date) => {
                        setFieldValue(name, date);

                        values[name] = date;

                        if (!date || !(values.From && values.To) || !date.isValid()) {
                            return;
                        }

                        values.From.set({
                            hours: 0,
                            minutes: 0,
                            seconds: 0,
                        });
                        values.To.set({
                            hours: 23,
                            minutes: 59,
                            seconds: 59,
                        });

                        filterDataRange(values);
                        setValue({ From: values.From, To: values.To });
                    };
                    return (
                        <form>
                            <FormControl className={classes.formControl} margin={'dense'}>
                                <DatePicker
                                    name={'From'}
                                    onBlur={handleBlur}
                                    error={!!(errors.From && touched.From)}
                                    maxDate={values.To || undefined}
                                    minDate={minDate}
                                    onChange={(date) =>
                                        filter('From', date)
                                    }
                                    value={values.From || null}
                                    margin={"dense"}
                                    emptyLabel={translations && translations['select_from'] ? translations['select_from'] : 'Please select date from'}
                                    label={translations && translations['select_from'] ? translations['select_from'] : 'Please select date from'}
                                    className={classes.cancel}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                                <DatePicker
                                    name={'To'}
                                    className={classes.cancel}
                                    onBlur={handleBlur}
                                    maxDate={values.maxDate ?? moment()}
                                    minDate={values.From ?? minDate}
                                    emptyLabel={translations && translations['select_to'] ? translations['select_to'] : 'Please select date to'}
                                    label={translations && translations['select_to'] ? translations['select_to'] : 'Please select date to'}
                                    error={!!(errors.To && touched.To)}
                                    onChange={(date) =>
                                        filter('To', date)
                                    }
                                    value={values.To || null}
                                    margin={"dense"}
                                    fullWidth={true}
                                    format={getDateFormat()}
                                />
                                {minDate && <FormHelperText>{translations["date_range_is_limited_to_1_year_before_now"] || "Date range is limited to 1 year before now"}</FormHelperText>}
                            </FormControl>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(DataRangeForm);
